import errorLgReducer from "./reducers";

export default errorLgReducer;